module.exports = __webpack_public_path__ + "static/media/download-black.63e77f03.svg";